import Swiper from "swiper"
import { find } from "utils/dom"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	  gsap.registerPlugin(ScrollTrigger);
		const globalDisco = document.querySelector('#gsap-girar-disco')
		const agulha = document.querySelector("#gsap-braco-agulha");
		
	// states 
	 	let subtitlesEnabled = false;
	
		let agulhaTimeline;

		let discoAnimation = null;
		let discoRotation = 0; // Armazena o progresso acumulado
		let lastTimestamp = 0;



		function updateProgressBar(r) {
			const val = ((r.value - r.min) / (r.max - r.min)) * 100;
			r.style.background = `linear-gradient(to right, white ${val}%, #808080 ${val}%)`;
		}

		function startDisco() {
  if (!globalDisco) return;

  // Mata animação anterior
  if (discoAnimation) discoAnimation.kill();

  // Configura uma animação infinita que aumenta a rotação baseado no tempo real
  discoAnimation = gsap.to({}, {
    duration: 10,
    repeat: -1,
    ease: "none",
    onUpdate: function() {
      const now = performance.now();

      if (!lastTimestamp) lastTimestamp = now;

      // Tempo decorrido desde a última atualização
      const delta = now - lastTimestamp;
      lastTimestamp = now;

      // Atualiza rotação: 360 graus em 5 segundos => 72 graus por segundo
      discoRotation = (discoRotation + (72 * delta / 1000)) % 360;

      // Aplica rotação no disco
      gsap.set(globalDisco, { rotate: discoRotation });
    }
  });
}

function pauseDisco() {
  if (!discoAnimation) return;

  // Mata a animação de incremento
  discoAnimation.kill();
  discoAnimation = null;

  // Reset timestamp para evitar pulo na próxima
  lastTimestamp = 0;

  // Faz uma desaceleração suave com um giro extra para suavizar a parada
  gsap.to(globalDisco, {
    rotate: discoRotation + 20,
    duration: 0.6,
    ease: "power2.out",
    onUpdate: () => {
      // Atualiza a rotação acumulada para o valor atual durante a desaceleração
      discoRotation = gsap.getProperty(globalDisco, "rotate") % 360;
    }
  });
}

  document.querySelector('.Main-Button').addEventListener('click', () => {
    subtitlesEnabled = !subtitlesEnabled;

		document.querySelector('.container-lyrics')?.classList.toggle('active')
    document.querySelector('.Main-Button').textContent = subtitlesEnabled
      ? 'subtitles enabled'
      : 'activate the subtitles';
  });

  function parseLRC(lrc) {
		 if (!lrc || typeof lrc !== 'string') return [];

    return lrc.split('\n').map(line => {
      const match = line.match(/\[(\d+):(\d+\.\d+)]\s*(.*)/);
      if (!match) return null;
      const min = parseInt(match[1]);
      const sec = parseFloat(match[2]);
      const time = min * 60 + sec;
      return { time, text: match[3] };
    }).filter(Boolean);
  }

	function showSubtitle(audio, container, lrcText) {
		const subtitles = parseLRC(lrcText);
		let currentIndex = -1;


		if (!subtitles.length) {
    container.innerHTML = `<p class="text-[#B2B2B2] italic text-center">Unavailable lyrics for this song. </p>`;
    return;
  }

		audio.addEventListener('timeupdate', () => {
			if (!subtitlesEnabled) {
				container.innerHTML = '';
				return;
			}

			const current = audio.currentTime;

			for (let i = 0; i < subtitles.length; i++) {
				if (current >= subtitles[i].time && (i + 1 === subtitles.length || current < subtitles[i + 1].time)) {
					if (currentIndex !== i) {
						currentIndex = i;

						// Número de linhas de contexto
						const linesBefore = 2;
						const linesAfter = 2;

						const start = Math.max(0, i - linesBefore);
						const end = Math.min(subtitles.length, i + linesAfter + 1);

						container.innerHTML = subtitles
							.slice(start, end)
							.map((line, idx) => {
								const isCurrent = start + idx === i;
								return `<p class="${isCurrent ? 'text-white font-bold legenda-ativa' : 'text-[#B2B2B2]'}">${line.text}</p>`;
							})
							.join('');
					}
					break;
				}
			}
		});
	}

  function player() {
    const players = document.querySelectorAll('.player');
    const lyricsContainer = document.querySelector('.container-lyrics');

    players.forEach((player) => {
      const audio = player.querySelector('audio');
      const btn = player.querySelector('.play-btn');
      const range = player.querySelector('.range');
      const lrcText = player.getAttribute('data-lrc')  || '';

      btn.addEventListener('click', () => {
        // Pausa todos os áudios
        players.forEach(p => {
          const a = p.querySelector('audio');
          const b = p.querySelector('.play-btn');
          if (a !== audio) {
            a.pause();
            b.textContent = '▶';
            p.classList.add('opacity-30');
            p.classList.remove('opacity-100');
          }
        });

        if (audio.paused) {
          audio.play();
          btn.textContent = '⏸';
          player.classList.add('opacity-100');
          player.classList.remove('opacity-30');

          showSubtitle(audio, lyricsContainer, lrcText);

					
					 startDisco()



						const index = [...players].indexOf(player);
						const angulosPorMusica = [-14, -8, -3];
						const angle = angulosPorMusica[Math.min(index, angulosPorMusica.length - 1)];

						if (agulhaTimeline) agulhaTimeline.kill();

						agulhaTimeline = gsap.timeline();

						// Animação plana e suave do braço da agulha
						agulhaTimeline
							// .to(agulha, {
							// 	y: -5,               // levanta verticalmente
							// 	scale: 1.02,          // levemente maior, como se afastasse
							// 	duration: 0.2,
							// 	ease: "power1.out",
							// 	transformOrigin: "80% 10%" 
							// })
							.to(agulha, {
								rotate: angle,        // move para a nova música
								duration: 0.35,
								ease: "power2.inOut"
							}, "<") // roda enquanto está levantando
							.to(agulha, {
								y: 0,                 // desce de volta
								scale: 1,             // volta ao tamanho normal
								duration: 0.2,
								ease: "power1.in"
							});


        } else {
          audio.pause();
          btn.textContent = '▶';

					 pauseDisco();

					 if (agulhaTimeline) agulhaTimeline.kill(); // para a animação anterior

						agulhaTimeline = gsap.timeline();

						agulhaTimeline.to("#gsap-braco-agulha", {
							// y: -15,
							// scale: 1.02,
							duration: 0.3,
							ease: "power1.out",
							transformOrigin: "80% 10%"
						});



        }
      });

      audio.addEventListener('timeupdate', () => {
        range.value = (audio.currentTime / audio.duration) * 100 || 0;

				updateProgressBar(range)
      });

      range.addEventListener('input', () => {
        audio.currentTime = (range.value / 100) * audio.duration;
      });
    });
  }

	function progressCustom(){
		const ranges = document.querySelectorAll('.custom-range');

		function updateBackground(range) {
			const val = ((range.value - range.min) / (range.max - range.min)) * 100;
			console.log(val)
			range.style.background = `linear-gradient(to right, white ${val}%, #808080 ${val}%)`;
		}

		ranges.forEach(range => {
			updateBackground(range); // Inicializa o fundo ao carregar
			range.addEventListener('input', () => updateBackground(range));
		});
	}


	function tabsVideosOld(){
		  document.querySelectorAll('.svg-para-cliques rect').forEach(rect => {
				rect.addEventListener('click', () => {
					const tabId = rect.dataset.tab;

					// Esconde todas as tabs
					document.querySelectorAll('.tab').forEach(tab => {
						tab.classList.add('hidden');
					});

					// Mostra a tab clicada
					const tab = document.getElementById(tabId);
					if (tab) tab.classList.remove('hidden');
				});
			});
	}

	function tabsVideos() {
		const scrollTarget = document.querySelector('#beat-box-gun-machine');

		document.querySelectorAll('.svg-para-cliques rect').forEach(rect => {
			rect.addEventListener('click', () => {
				const tabId = rect.dataset.tab;

				// Esconde todas as tabs
				document.querySelectorAll('.tab').forEach(tab => {
					tab.classList.add('hidden');
				});

				// Mostra a tab clicada
				const tab = document.getElementById(tabId);
				if (tab) {
					tab.classList.remove('hidden');

				
						// const scrollTarget = document.querySelector('#beat-box-gun-machine');
						// if (scrollTarget) {
						// 	scrollTarget.scrollIntoView({
						// 		behavior: 'smooth',
						// 		block: 'start' // ou 'center' se quiser o elemento no meio da tela
						// 	});
						// }
					
				

					// Animação com GSAP
					const left = tab.querySelector('.tab-left');
					const right = tab.querySelector('.tab-right');

					if (left && right) {
						// Zera antes
						gsap.set([left, right], { opacity: 0, x: 0 });

						gsap.fromTo(left,
							{ x: '-50%', opacity: 0 },
							{ x: '0%', opacity: 1, duration: 0.8, ease: 'power3.out' }
						);
						gsap.fromTo(right,
							{ x: '50%', opacity: 0 },
							{ x: '0%', opacity: 1, duration: 0.8, ease: 'power3.out', delay: 0.1 }
						);
					}
				}
			});
		});
	}
		
	progressCustom();

 	player();

	tabsVideos();

	
var swiperNoticias = new Swiper(".swiper-noticias", {
	navigation: {
	nextEl: ".swiper-button-noticias-next",
	prevEl: ".swiper-button-noticias-prev",
	},
	on: {
    slideChange: function () {
      const activeIndex = this.activeIndex;
	  const allVideos = document.querySelectorAll('.swiper-noticias .swiper-slide video')
	  allVideos.forEach(video => {
        video.pause();
        video.currentTime = 0; // opcional: reinicia o vídeo
      });
      	const activeSlide = this.slides[activeIndex];
    	activeSlide.querySelector('video').play()
    }
  }
});

 var swiperSocialMedia = new Swiper(".swiper-social-media", {
 	slidesPerView:1,
 	loop:true,
 	navigation: {
 	nextEl: ".swiper-button-social-media-next",
 	prevEl: ".swiper-button-social-media-prev",
 	},
 	on: {
     slideChange: async function () {
       	// activeIndex = this.activeIndex;
      	const allAudios = document.querySelectorAll('.swiper-social-media .swiper-slide audio');
	 
		allAudios.forEach(audio => {
			audio.pause();
			audio.currentTime = 0;
		});
     }
   }

 });



var swiperVideoMedia = new Swiper(".swiper-video-media", {
	slidesPerView:1,
	navigation: {
	nextEl: ".swiper-button-video-media-next",
	prevEl: ".swiper-button-video-media-prev",
	},
	on: {
    slideChange: function () {
      const activeIndex = this.activeIndex;
	  const allVideos = document.querySelectorAll('.swiper-video-media .swiper-slide video')
	  allVideos.forEach(video => {
        video.pause();
        video.currentTime = 0; // opcional: reinicia o vídeo
      });
      	const activeSlide = this.slides[activeIndex];
    	activeSlide.querySelector('video').play()
    }
  }
});

 function player2() {
    const players = document.querySelectorAll('.player-2');

    players.forEach((player) => {
      const audio = player.querySelector('audio');
      const btn = player.querySelector('.play-btn');
      const range = player.querySelector('.range');
      const lrcText = player.getAttribute('data-lrc')  || '';

      btn.addEventListener('click', () => {
        // Pausa todos os áudios
        players.forEach(p => {
          const a = p.querySelector('audio');
          const b = p.querySelector('.play-btn');
          if (a !== audio) {
            a.pause();
            b.textContent = '▶';
            p.classList.add('opacity-30');
            p.classList.remove('opacity-100');
          }
        });

        if (audio.paused) {
          audio.play();
          btn.textContent = '⏸';
          player.classList.add('opacity-100');
          player.classList.remove('opacity-30');

        } else {
          audio.pause();
          btn.textContent = '▶';
        }
      });

      audio.addEventListener('timeupdate', () => {
        range.value = (audio.currentTime / audio.duration) * 100 || 0;

				updateProgressBar(range)
      });

      range.addEventListener('input', () => {
        audio.currentTime = (range.value / 100) * audio.duration;
      });
    });
  }

player2()

function showVideo() {
	const videos = document.querySelectorAll('#video-pb iframe')
	const btns = document.querySelectorAll('#video-pb .btn')
	btns.forEach(i =>{
		i.addEventListener('click', (e)=>{
			const svgs =  document.querySelectorAll('#video-pb .svg-video')
			svgs.forEach(svg =>{
				svg.classList.add('hidden')
			})

			videos.forEach(video=>{
				video.classList.add('hidden')
			})

			if (i.classList.contains("video-1")){
				const video1 = document.querySelector('.video-1')
				video1.classList.remove('hidden')				
			}

			if (i.classList.contains("video-2")){
				const video2 = document.querySelector('.video-2')
				video2.classList.remove('hidden')
			}
				
			const svg = i.querySelector('.svg-video')
			svg.classList.remove('hidden')
		})
	})

	
	
}

showVideo()

	console.log('Page home');
}